export default __webpack_public_path__ + "static/media/package.09a7f2a2.svg";